import { Action } from "csi/def/Action";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import ActionData from "csi/heading/ActionData";
import BooleanRen from "csi/heading/Boolean";
import declare from "dojo/_base/declare";

export = declare(BooleanRen, {

	/**
	 * @override
	 * Add user details node
	 */
	addRendererDependencyPaths: function(h: Heading, paths: string[]): void {
		paths.push("Child:Details");
	},

	/**
	 * @override
	 * Remove the tooltip action.
	 */
	_getRenderAction(ctx: Context, h: Heading): ActionData {
		const ad = this.inherited<ActionData>(arguments);
		if (!ad || !ad.action.hasAccess(ctx)) {
			return null;
		}
		ad.bTooltip = false;
		return ad;
	},

	/**
	 * @override
	 * Modify the "Deactivate C8 User" action of a Ziflow Registered User.
	 */
	getAction(ctx: Context, h: Heading): Action {
		if (this._getValue(ctx, h) && ctx.cache.get(ctx.getNode().Details)?.ZiflowRegisteredUser) {
			return this.inherited<Action>(arguments);
		}
		const a = this._getRenderActionForHeading(ctx, h);
		a.heading = h;
		a.m_right = h.getRight() || a.m_right;
		return a;
	},
});
